import Vue from 'vue'
import Home from './home.vue'
import store from '@/store'
import ElementUI from 'element-ui'
import { message } from '../../api/resetMsg'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.prototype.$message = message
Vue.config.productionTip = false

new Vue({
    store,
    render:h => h(Home)
}).$mount('#app')